import { Maybe } from '@/utils/types'
import { TitleItemType } from '../types'
import { ContentInteraction } from '../useContentInteraction'

type Surface = 'player'

/**
 * Interaction builder for end-of-asset recommendation titles
 * Used for tracking user interactions with recommended content shown at the end of a video
 */
export class EndOfAssetRailItemInteraction extends ContentInteraction<Surface> {
  constructor(item: { id: string; __typename: Maybe<TitleItemType>; attribution: unknown }) {
    super(item)
  }
}
